export default "__VITE_ASSET__jeZZY0cK__"